(() => {
  if (document.getElementById('mf-mobile-buy')) return;
  const main = document.querySelector('main');
  if (!main) return;
  const bar = document.createElement('aside');
  bar.id = 'mf-mobile-buy';
  bar.setAttribute('aria-label', 'Compra do produto');
  bar.hidden = true;
  bar.innerHTML = '<p class="mf-mobile-buy__error" role="status" aria-live="polite"></p><button type="button" class="button button--full-width button--primary">Adicionar ao carrinho</button>';
  document.body.appendChild(bar);
  const button = bar.querySelector('button');
  const error = bar.querySelector('p');
  const mobile = window.matchMedia('(max-width: 749px)');
  let queued = false;
  let source;
  function update() {
    queued = false;
    source = main.querySelector('[id^="ProductSubmitButton-"]');
    const panel = source && source.closest('product-form');
    const rect = source && source.getBoundingClientRect();
    const modalOpen = document.querySelector('cart-drawer.active, cart-notification.active, product-modal[open], dialog[open], details[open].menu-opening');
    const visible = !!(mobile.matches && source && source.getClientRects().length && rect.bottom < 0 && !modalOpen);
    bar.hidden = !visible;
    document.body.classList.toggle('mf-mobile-buy-visible', visible);
    if (!source) return;
    const busy = source.classList.contains('loading');
    button.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
    button.setAttribute('aria-busy', String(busy));
    button.textContent = busy ? 'Adicionando…' : (source.querySelector('span:not(.hidden)')?.textContent.trim() || source.textContent.trim() || 'Adicionar ao carrinho');
    const wrapper = panel?.querySelector('.product-form__error-message-wrapper');
    const message = wrapper && !wrapper.hidden ? wrapper.querySelector('.product-form__error-message')?.textContent.trim() : '';
    error.textContent = message || '';
    error.hidden = !message;
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  button.addEventListener('click', () => {
    update();
    if (!source || button.disabled) return;
    source.click();
    schedule();
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true, attributes: true, characterData: true });
  document.querySelectorAll('cart-drawer, cart-notification, product-modal, header details').forEach(element => {
    new MutationObserver(schedule).observe(element, { attributes: true });
  });
  document.addEventListener('shopify:section:load', schedule);
  update();
})();